"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.mountNavigationDrawer = exports.mountNavigationHeader = void 0;
var react_1 = __importStar(require("react"));
var lodash_1 = require("lodash");
var NavigationSettings_1 = require("./NavigationSettings");
var pages_common_1 = require("@qwilr/pages-common");
var styles = __importStar(require("./NavigationMenu.css"));
var DIProvider_1 = __importDefault(require("@CommonFrontend/DIProvider/DIProvider"));
var inversify_1 = require("inversify");
var NavigationStore_1 = __importDefault(require("./NavigationStore"));
var AngularSyncStore_1 = require("@CommonFrontend/Utils/AngularSyncStore");
var inversify_react_1 = require("inversify-react");
var mobx_react_lite_1 = require("mobx-react-lite");
var EditableMenuItem_1 = require("./EditableMenuItem");
var mobx_1 = require("mobx");
var MenuItemsFooter_1 = require("./MenuItemsFooter");
var FeatureFlag_1 = __importDefault(require("@CommonFrontendBackend/FeatureFlag"));
var NavigationHeaderContainer = (0, mobx_react_lite_1.observer)(function (_a) {
    var _b;
    var pageQuoteTotalStore = _a.pageQuoteTotalStore;
    var project = (0, inversify_react_1.useInjection)("projectStore");
    var user = (0, inversify_react_1.useInjection)("user");
    var usingFeature = (0, inversify_react_1.useInjection)("usingFeature");
    var telemetry = (0, inversify_react_1.useInjection)("telemetry");
    var navigationStore = (0, inversify_react_1.useInjection)(NavigationStore_1.default);
    var showNavWhileEditing = (0, pages_common_1.useNavigationContext)().showNavWhileEditing;
    var layout = navigationStore.layout;
    var springboardMenuEnabled = usingFeature(FeatureFlag_1.default.ConsumerVirality) &&
        !usingFeature(FeatureFlag_1.default.DisableClerkOnPublicPages) &&
        !usingFeature(FeatureFlag_1.default.OptOutSpringboardEngagementMenu) &&
        navigationStore.springboardMenuEnabled;
    var pageTotal = pageQuoteTotalStore.getTotal(false);
    (0, react_1.useEffect)(function () {
        pages_common_1.PubSub.publish("qwilr:quote-total-changed", { total: pageTotal });
    }, [pageTotal]);
    var hasQuoteBlock = project.quoteBlockCount > 0;
    var quote;
    if (hasQuoteBlock &&
        pageQuoteTotalStore.hasQuoteCurrency &&
        pageQuoteTotalStore.showQuoteTotal &&
        navigationStore.showQuoteTotal) {
        quote = {
            currency: pageQuoteTotalStore.getCurrency(false),
            currencyLocale: (_b = project.currencyLocale) !== null && _b !== void 0 ? _b : undefined,
            initialTotal: pageTotal,
            showDecimalPlaces: pageQuoteTotalStore.showDecimalPlaces,
        };
    }
    var hasAcceptBlock = !!navigationStore.accept;
    var showQuoteTotal = !!quote;
    return (react_1.default.createElement("div", { className: styles.wrapper },
        react_1.default.createElement(pages_common_1.TelemetryContextProvider, { track: telemetry.track },
            react_1.default.createElement(pages_common_1.ConfigurationContextProvider, { pageHash: "", publicApiBaseUrl: "" },
                react_1.default.createElement(pages_common_1.SpringboardContextProvider, { pageOwnerEmail: navigationStore.showContactDetails ? user.email : undefined, pageHash: "", authAppBaseUrl: "", springboardAppBaseUrl: "", consumerDataServiceUrl: "" },
                    react_1.default.createElement(pages_common_1.SpringboardEngagementViewStoreContextProvider, { demoMode: true, enabled: springboardMenuEnabled, isInline: showQuoteTotal || hasAcceptBlock },
                        react_1.default.createElement(pages_common_1.NavigationHeader, { title: project.name, layout: layout, mode: "editor", showDrawer: navigationStore.showDrawer, quote: quote, backgroundColor: navigationStore.themeAwareBackgroundColor, showEngagementMenu: springboardMenuEnabled, accept: navigationStore.accept }),
                        project.isEditable && (react_1.default.createElement(NavigationSettings_1.NavigationSettings, { className: styles.settingsWrapper({
                                layout: layout,
                                isNavigationShown: showNavWhileEditing,
                                hasActions: !!navigationStore.accept || !!quote || springboardMenuEnabled,
                            }) }))))))));
});
var NavigationDrawerContainer = (0, mobx_react_lite_1.observer)(function () {
    var _a, _b, _c, _d, _e, _f, _g;
    var navigationStore = (0, inversify_react_1.useInjection)(NavigationStore_1.default);
    var project = (0, inversify_react_1.useInjection)("projectStore");
    var accountName = (0, inversify_react_1.useInjection)("account").name;
    var items = (0, mobx_1.toJS)((_a = navigationStore.items) !== null && _a !== void 0 ? _a : [], { recurseEverything: true });
    var layout = navigationStore.layout;
    var telemetry = lodash_1.noop;
    var hasEditorInfoBanner = !project.isEditable || project.isAccepted;
    var pageOwner = {
        organisation: accountName,
        firstName: (_c = (_b = project.owner) === null || _b === void 0 ? void 0 : _b.firstName) !== null && _c !== void 0 ? _c : "",
        lastName: (_e = (_d = project.owner) === null || _d === void 0 ? void 0 : _d.lastName) !== null && _e !== void 0 ? _e : "",
        email: (_g = (_f = project.owner) === null || _f === void 0 ? void 0 : _f.email) !== null && _g !== void 0 ? _g : "",
        contactEnabled: navigationStore.showContactDetails,
    };
    return (react_1.default.createElement(pages_common_1.TelemetryContextProvider, { track: telemetry },
        react_1.default.createElement(pages_common_1.SpringboardContextProvider, { pageOwnerEmail: navigationStore.showContactDetails ? project.owner.email : undefined, pageHash: "", authAppBaseUrl: "", springboardAppBaseUrl: "", consumerDataServiceUrl: "" },
            react_1.default.createElement(pages_common_1.SpringboardEngagementViewStoreContextProvider, { demoMode: true, enabled: false, isInline: false },
                react_1.default.createElement(pages_common_1.NavigationDrawer, { layout: layout, showDrawer: navigationStore.showDrawer, mode: "editor", items: items, backgroundColor: navigationStore.themeAwareBackgroundColor, pageOwner: pageOwner, withEditorInfoBanner: hasEditorInfoBanner })))));
});
var ContextProvider = function (_a) {
    var angularSyncServices = _a.angularSyncServices, children = _a.children;
    var project = (0, inversify_react_1.useInjection)("projectStore");
    return (react_1.default.createElement(DIProvider_1.default, { container: function () {
            var container = new inversify_1.Container({ skipBaseClassChecks: true });
            container.bind(AngularSyncStore_1.AngularSyncServices.$).toConstantValue(angularSyncServices);
            container.bind(NavigationStore_1.default).toSelf().inSingletonScope();
            return container;
        } },
        react_1.default.createElement(pages_common_1.NavigationContextProvider, { projectId: project._id, mode: "editor", value: project.isEditable ? { MenuItemWrapper: EditableMenuItem_1.EditableMenuItem, MenuItemsFooter: MenuItemsFooter_1.MenuItemsFooter } : undefined }, children)));
};
var mountNavigationComponent = function (Component, mountReactComponent, angularSyncServices, props) {
    return mountReactComponent(react_1.default.createElement(ContextProvider, { angularSyncServices: angularSyncServices },
        react_1.default.createElement(pages_common_1.AuthenticationContextProvider, { isSignedIn: false, isInitialized: true, signOut: function () { return Promise.resolve(); }, getToken: function () { return Promise.resolve(""); } },
            react_1.default.createElement(Component, __assign({}, props)))));
};
function mountNavigationHeader(mountReactComponent, angularSyncServices, pageQuoteTotalStore) {
    return mountNavigationComponent(NavigationHeaderContainer, mountReactComponent, angularSyncServices, {
        pageQuoteTotalStore: pageQuoteTotalStore,
    });
}
exports.mountNavigationHeader = mountNavigationHeader;
function mountNavigationDrawer(mountReactComponent, angularSyncServices) {
    return mountNavigationComponent(NavigationDrawerContainer, mountReactComponent, angularSyncServices);
}
exports.mountNavigationDrawer = mountNavigationDrawer;
